export const firstLineExecution = () => {
  window.orca = window.orca || {};
  window.orca.version = window.orca.version || {};
  window.orca.version["orca-ui"] = VERSION;
};
